// import { useSelector } from "react-redux";


const AkshayaPatraCustomerMessages = () => {
    //   const OrgId = useSelector((state) => state.auth.org_id)
      // console.log(OrgId, 'org_id__________')
      
      return (
        <div className="iframe-div">
            <iframe src= {`https://iiplwork.retool.com/embedded/public/489739eb-8a21-499e-8042-adcc3f7ed21e`}
            className="iframe-style"></iframe>
        </div>
      )
    };
    
    export default AkshayaPatraCustomerMessages;
    